<template>
  <section class="login-page">
    <section
      class="page-content login-content"
      :class="{ 'rest-password': loginType == 'forget' }"
    >
      <div class="sp-illustration" v-if="PLAT == 'shopkeeper'">
        <div class="welcome">
          Hello,<br />
          Welcome to <br />Shopkeeper
        </div>
        <technicalSupport></technicalSupport>
      </div>
      <div class="ua-illustration" v-if="PLAT == 'unexadmin'">
        <div class="welcome">
          Hello,<br />
          Welcome to <br />UNEX-Admin
        </div>
        <technicalSupport></technicalSupport>
      </div>
      <div class="login_wrapper">
        <div class="login">
          <div class="logo-panel">
            <img
              src="../images/newlogin/logo-shopkeeper.png"
              v-if="PLAT == 'shopkeeper'"
            />
            <img
              src="../images/newlogin/logo-unex.png"
              v-if="PLAT == 'unexadmin'"
            />
            <span class="logo-title" v-if="PLAT == 'shopkeeper'"
              >Shopkeeper</span
            >
            <span class="logo-title" v-if="PLAT == 'unexadmin'"
              >UNEX-Admin</span
            >
          </div>
          <accountLogin
            @afterLogin="afterLogin"
            @setDialog="setDialog"
            v-if="loginType == 'account'"
          ></accountLogin>
          <mobileLogin
            @afterLogin="afterLogin"
            v-if="loginType == 'mobile'"
          ></mobileLogin>
          <forgetPassword
            @afterLogin="afterLogin"
            v-if="loginType == 'forget'"
          ></forgetPassword>
        </div>
      </div>
    </section>
    <section
      class="login-loading"
      :class="loadingShow ? 'index-loading-show' : 'index-loading-hide'"
    >
      <section>
        <img src="../images/loading_fff.gif" />
        <span class="login-text">Welcome Back</span>
      </section>
    </section>
    <forcedReset :showDialog="showDialog" @setDialog="setDialog"></forcedReset>
  </section>
</template>
<script>
import "../js/parallax";
import axiosSet from "../preset/axios";
import { buildFeedback } from "../js/common";
import store from "store";
import cookie from "js-cookie";
import { Base64 } from "js-base64";
import { setTimeout } from "timers";
import forcedReset from "../components/login/forcedReset";
import accountLogin from "../components/login/accountLogin";
import mobileLogin from "../components/login/mobileLogin";
import forgetPassword from "../components/login/resetPassword";
import technicalSupport from "../components/login/technicalSupport";
import { mapState, mapActions } from "vuex";

export default {
  data() {
    return {
      PLAT: process.env.PLAT,
      version: "version" + " " + process.env.VERSION,
      title: process.env.PLAT.toUpperCase(),
      account: {
        username: cookie.get("username"), // "",
        password: cookie.get("password")
          ? Base64.decode(cookie.get("password"))
          : "", // "",
        loginCode: "",
        codeKey: "",
        rememberMe: false,
        newpassword: null,
        confirmPassword: null
      },
      loadingShow: false,
      timer: null,
      errorPlat: process.env.PLAT == "shopkeeper" ? "1019" : "1020",
      showDialog: false
    };
  },
  components: {
    forcedReset,
    accountLogin,
    mobileLogin,
    forgetPassword,
    technicalSupport
  },
  watch: {},
  computed: {
    ...mapState({
      loginType: state => state.frame.login.loginType
    })
  },
  async mounted() {
    if (!localStorage.getItem("account")) {
      let getMyInfo = await this.$store.dispatch("frame/getMyInfo", {});
      if (getMyInfo && getMyInfo.data && getMyInfo.data.account) {
        this.afterLogin({});
        return;
      }
    }
    axiosSet.withCredentials();
    this.getCaptcha();
    this.getMyInfo();
  },
  methods: {
    ...mapActions({
      getCaptcha: "frame/login/getCaptcha"
    }),
    async getMyInfo() {
      let res = await this.$store.dispatch("frame/getMyInfo", {});
      this.showDialog = res.code.includes(2117);
    },
    async afterLogin(res) {
      // 保存token
      window.localStorage.setItem("access-token", res.data);
      window.sessionStorage.removeItem("storeInfo");
      // this.$store.state.admin.$storeInfo = {};
      this.$store.state.frame.$token = res.data;
      this.$store.commit("frame/setToken", res.data);

      this.timer = setTimeout(() => {
        this.loadingShow = true;
        this.timer = null;
      }, 300);
      // Axios.defaults.headers.common['access-token'] = res.data;
      try {
        await Promise.all([this.getMenu(), this.getAuth(), this.getUserInfo()]);
        if (process.env.PLAT.toUpperCase() === "SHOPKEEPER") {
          buildFeedback({
            platform: "11",
            platformDisplayName: "SHOPKEEPER",
            user: store.get("account"),
            backend: process.env.branch
          });
        }
      } catch (e) {
        this.loadingShow = false;
      }
      this.timer && clearTimeout(this.timer);
      this.timer = null;
      if(await this.checkVersion()){
        this.$router.replace({ path: "/" });
      }
    },
    async checkVersion(){
      return new Promise(async (resolve)=>{
        if(process.env.PLAT === 'shopkeeper'){
          let res = await this.$store.dispatch('frame/getReleaseLast')
          if(res.success && res.data && res.data.show){
            this.$alert(res.data.subTitle, res.data.title, {
              confirmButtonText: '查看',
              showClose: false,
              callback: () => {
                const config = {
                  name: 'releaseCheck',
                  params: { id: res.data.id }
                }
                this.$router.push({
                  name: 'releaseHistory',
                })
                window.history.pushState(null,null,window.location.origin+'/admin/releaseHistory')
                this.$router.push(config)
                resolve(false)
              }
            })
          }else{
            resolve(true)
          }
        }{
          resolve(true)
        }
      })
    },
    async getMenu() {
      // 左侧菜单栏
      let language = this.$i18n && this.$i18n.locale;
      let menuRes = await this.$store.dispatch("frame/getMenuTree", {});
      store.set("menuTree", menuRes.data);
      this.$store.commit("frame/menuTreeAdapter", {
        language: language || "zh-cn",
        data: store.get("menuTree")
      });
    },
    async getAuth() {
      // 各种权限
      let allResource = await this.$store.dispatch(
        "frame/getUserAllResource",
        {}
      );
      store.set("allResource", allResource.data);
      this.$store.commit("frame/allResourceAdapter", allResource.data);
    },
    async getUserInfo() {
      // 我的信息和顶栏
      let getMyInfo = await this.$store.dispatch("frame/getMyInfo", {});
      store.set("account", getMyInfo.data.account);
      this.$store.commit("frame/setToper", {
        name: getMyInfo.data.account,
        assist: ""
      });
      if (getMyInfo.data.userTenantVO) {
        localStorage.setItem("tenantCode", getMyInfo.data.userTenantVO.tenantCode);
        store.set("tenantName", getMyInfo.data.userTenantVO.tenantName);
        store.set("userId", getMyInfo.data.userId);
        this.$store.commit("frame/setToper", {
          name: getMyInfo.data.account,
          assist: getMyInfo.data.userTenantVO.tenantName
        });
      }
    },
    setDialog(val) {
      this.showDialog = val ? val : false;
    },
  }
};
</script>
<style lang="scss">
.login-loading {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 1);

  padding-top: 30%;
  text-align: center;

  &.index-loading-show {
    // transition: all 1s;
    pointer-events: auto;
    opacity: 1;
    z-index: 2000;
  }
  &.index-loading-hide {
    opacity: 0;
    pointer-events: none;
    // transition: all 1s;
    z-index: 0;
  }
  > section {
    position: absolute;
    top: 40%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  img {
    width: 64px;
    height: 64px;
  }
  .login-text {
    font-size: 24px;
    font-weight: 500;
    color: #333;
    margin-top: 24px;
    display: block;
    text-align: center;
  }
}
</style>
